import React, { useState, useEffect } from "react";
import { Form, Input, Select, Button, message } from "antd";

const CommercialInfo = ({ companyData, apiUrl }) => {
  const [formData, setFormData] = useState({
    taxOffice: "",
    taxNumber: "",
    companyType: "",
    iban: ""
  });

  useEffect(() => {
    if (companyData.length) {
      setFormData({
        taxOffice: companyData[0]?.commercialInfo?.taxOffice || "",
        taxNumber: companyData[0]?.commercialInfo?.taxNumber || "",
        companyType: companyData[0]?.commercialInfo?.companyType || "",
        iban: companyData[0]?.commercialInfo?.ibanList?.[0] || ""
      });
    }
  }, [companyData]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (value) => {
    setFormData({ ...formData, companyType: value });
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/companyProfile/update/${companyData[0]?._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            commercialInfo: {
              taxOffice: formData.taxOffice,
              taxNumber: formData.taxNumber,
              companyType: formData.companyType,
              ibanList: [formData.iban]
            }
          })
        }
      );

      const result = await response.json();
      if (response.ok) {
        message.success("Ticari Bilgiler Güncellendi");
      } else {
        message.error(result.message || "Ticari Bilgiler Güncellenirken Bir Hata Oluştu.");
      }
    } catch (error) {
      console.error("Error updating commercial info:", error);
      message.error("Ticari Bilgiler Güncellenirken Bir Hata Oluştu.");
    }
  };

  if (!companyData.length) return <p>Loading...</p>;

  return (
    <Form layout="vertical" className="grid grid-cols-2 gap-4">
      <Form.Item label="Vergi Dairesi">
        <Input
          name="taxOffice"
          value={formData.taxOffice}
          onChange={handleChange}
          placeholder="Vergi Dairesi Giriniz"
        />
      </Form.Item>
      <Form.Item label="Vergi Numarası">
        <Input
          name="taxNumber"
          value={formData.taxNumber}
          onChange={handleChange}
          placeholder="Vergi Numarası Giriniz"
        />
      </Form.Item>
      <Form.Item label="Şirket Tipi">
        <Select
          value={formData.companyType}
          onChange={handleSelectChange}
          placeholder="Şirket Tipi Seçiniz"
        >
          <Select.Option value="Limited">Limited</Select.Option>
          <Select.Option value="Anonim">Anonim</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item label="IBAN">
        <Input
          name="iban"
          value={formData.iban}
          onChange={handleChange}
          placeholder="IBAN Giriniz"
        />
      </Form.Item>
      <Button type="primary" className="col-span-2" onClick={handleSubmit}>
        Değişiklikleri Kaydet
      </Button>
    </Form>
  );
};

export default CommercialInfo;
